// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CertificateMonitoring_success__rRjGa {
  color: #15ad5c;
  cursor: pointer;
}

.CertificateMonitoring_error__nU5KR {
  color: #e64949;
  cursor: pointer;
}

.CertificateMonitoring_disabledText__fzubV {
  background-color: #e9ecef;
  padding: 0.375rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  min-height: 38px;
  max-height: 200px;
  overflow-y: auto;
  color: #495057;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.CertificateMonitoring_noComments__b4D2n {
  font-style: italic;
  color: #6c757d;
}

.CertificateMonitoring_dropdownMenu__Rqrzd {
  transform: none !important;
  left: -170px !important;
}

.CertificateMonitoring_dropdownItem__XB9h8 {
  font-size: 12px;
}

tbody tr:nth-last-child(-n+2) td:last-child .CertificateMonitoring_dropdownMenu__Rqrzd {
  top: -95px !important;
}

.CertificateMonitoring_certificateTitleContainer__q-YSq {
  position: relative;
  display: inline-block;
}

.CertificateMonitoring_certificateCommentsContainer__119J4 {
  position: absolute;
  top: -15px;
  right: -20px;
}

.CertificateMonitoring_certificateCommentsSpan__zBvIL {
  padding: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #4FC3F7;
  color: white;
}

.CertificateMonitoring_completeModalBody__RMetB {
  display: flex;
  justify-content: center;
  align-items: center;
}

.CertificateMonitoring_monitoringDashboard__p5n8a {
  margin-top: 20px;
}
.CertificateMonitoring_monitoringDashboard__p5n8a table {
  table-layout: fixed;
  width: 100%;
}
.CertificateMonitoring_monitoringDashboard__p5n8a th {
  color: rgba(17, 17, 17, 0.6392156863);
}
.CertificateMonitoring_monitoringDashboard__p5n8a th, .CertificateMonitoring_monitoringDashboard__p5n8a td {
  width: 14.28%;
  text-align: center;
}
.CertificateMonitoring_monitoringDashboard__p5n8a th:first-child, .CertificateMonitoring_monitoringDashboard__p5n8a td:first-child {
  text-align: left;
}
.CertificateMonitoring_monitoringDashboard__p5n8a .CertificateMonitoring_cellLightButton__vL4qM {
  background-color: #dedede;
}
.CertificateMonitoring_monitoringDashboard__p5n8a .CertificateMonitoring_cellLightButton__vL4qM:disabled {
  background-color: #dedede;
  border: none;
  color: black;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/CertificateMonitoring/CertificateMonitoring.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;AACF;;AAEA;EACE,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,qBAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;AACF;;AAEA;EACE,0BAAA;EACA,uBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,qBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;AAAF;;AAGA;EACE,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAAF;;AAEA;EACE,gBAAA;AACF;AACE;EACE,mBAAA;EACA,WAAA;AACJ;AAEE;EACE,qCAAA;AAAJ;AAGE;EACE,aAAA;EACA,kBAAA;AADJ;AAIE;EACE,gBAAA;AAFJ;AAKE;EACE,yBAAA;AAHJ;AAME;EACE,yBAAA;EACA,YAAA;EACA,YAAA;AAJJ","sourcesContent":[".success {\r\n  color: #15ad5c;\r\n  cursor: pointer;\r\n}\r\n\r\n.error {\r\n  color: #e64949;\r\n  cursor: pointer;\r\n}\r\n\r\n.disabledText {\r\n  background-color: #e9ecef;\r\n  padding: 0.375rem 0.75rem;\r\n  border: 1px solid #ced4da;\r\n  border-radius: 0.25rem;\r\n  min-height: 38px;\r\n  max-height: 200px;\r\n  overflow-y: auto;\r\n  color: #495057;\r\n  word-wrap: break-word;\r\n  white-space: pre-wrap;\r\n}\r\n\r\n.noComments{\r\n  font-style: italic;\r\n  color: #6c757d;\r\n}\r\n\r\n.dropdownMenu {\r\n  transform: none !important;\r\n  left: -170px !important;\r\n}\r\n\r\n.dropdownItem{\r\n  font-size: 12px;\r\n}\r\n\r\n// Last column of the last 2 rows of table\r\ntbody tr:nth-last-child(-n+2) td:last-child .dropdownMenu{\r\n  top: -95px !important;\r\n}\r\n\r\n.certificateTitleContainer {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n.certificateCommentsContainer{\r\n  position: absolute;\r\n  top: -15px;\r\n  right: -20px;\r\n}\r\n\r\n.certificateCommentsSpan{\r\n  padding: 4px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 20px;\r\n  height: 20px;\r\n  border-radius: 50%;\r\n  background-color: #4FC3F7;\r\n  color: white;\r\n}\r\n\r\n.completeModalBody {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.monitoringDashboard {\r\n  margin-top: 20px;\r\n\r\n  table {\r\n    table-layout: fixed;\r\n    width: 100%;\r\n  }\r\n\r\n  th{\r\n    color: #111111a3;\r\n  }\r\n\r\n  th, td {\r\n    width: 14.28%; // Equal width for 7 columns\r\n    text-align: center;\r\n  }\r\n\r\n  th:first-child, td:first-child {\r\n    text-align: left;\r\n  }\r\n  \r\n  .cellLightButton{\r\n    background-color: #dedede;\r\n  }\r\n  \r\n  .cellLightButton:disabled{\r\n    background-color: #dedede;\r\n    border: none;\r\n    color: black;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"success": `CertificateMonitoring_success__rRjGa`,
	"error": `CertificateMonitoring_error__nU5KR`,
	"disabledText": `CertificateMonitoring_disabledText__fzubV`,
	"noComments": `CertificateMonitoring_noComments__b4D2n`,
	"dropdownMenu": `CertificateMonitoring_dropdownMenu__Rqrzd`,
	"dropdownItem": `CertificateMonitoring_dropdownItem__XB9h8`,
	"certificateTitleContainer": `CertificateMonitoring_certificateTitleContainer__q-YSq`,
	"certificateCommentsContainer": `CertificateMonitoring_certificateCommentsContainer__119J4`,
	"certificateCommentsSpan": `CertificateMonitoring_certificateCommentsSpan__zBvIL`,
	"completeModalBody": `CertificateMonitoring_completeModalBody__RMetB`,
	"monitoringDashboard": `CertificateMonitoring_monitoringDashboard__p5n8a`,
	"cellLightButton": `CertificateMonitoring_cellLightButton__vL4qM`
};
export default ___CSS_LOADER_EXPORT___;
